import throttle  from 'lodash/throttle'

export default {
    mounted: function (el, binding) {
        const { value: fn, arg: delay = 300 } = binding;
        el.addEventListener('click', throttle(fn, delay))
    }
}
